module.exports = __webpack_public_path__ + "img/logo2.b1701ea7.jpg";